import { SortBy } from '@modules/quantify/store/types';
import { GridLogicOperator } from '@mui/x-data-grid-pro';
import { GridInitialStatePro } from '@mui/x-data-grid-pro/models/gridStatePro';
import { useMemo } from 'react';

export function useGridInitialState(sortBy: SortBy): GridInitialStatePro {
  return useMemo(() => {
    return {
      columns: {
        columnVisibilityModel: {
          id: false,
        },
      },
      filter: {
        filterModel: {
          items: [],
          quickFilterLogicOperator: GridLogicOperator.Or,
        },
      },
      sorting: {
        sortModel: [
          {
            field: sortBy.field,
            sort: sortBy.isAsc ? 'asc' : 'desc',
          },
        ],
      },
    };
  }, [sortBy]);
}
